import React from 'react';
import PropTypes from 'prop-types';

class TouchObserver extends React.Component {
  state = { touched: false };

  handleOnTouchStart = () => {
    this.setState({ touched: true });
  };

  handleOnTouchEnd = () => {
    this.setState({ touched: false });
  };

  render() {
    return (
      <div
        onTouchStart={this.handleOnTouchStart}
        onTouchEnd={this.handleOnTouchEnd}
      >
        {this.props.children({ touched: this.state.touched })}
      </div>
    );
  }
}

TouchObserver.propTypes = {
  children: PropTypes.func,
};

export default TouchObserver;
